<div class="nav-drawer">
  <h2>{{ noWinner ? 'No winner' : (winner === 0 || winner === 1) ? 'Winner:' : 'Current player:' }}</h2>
  <div
    *ngIf="!noWinner"
    style="display: flex; align-items: center; padding-top: 1px;"
  >
    <svg
      *ngIf="(currentPlayer === 1 || winner === 1) && winner !== 0"
      style="width:24px;height:24px" viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z" />
    </svg>
    <svg
      *ngIf="(currentPlayer === 0 || winner === 0) && winner !== 1"
      style="width:24px;height:24px" viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
    </svg>
  </div>
</div>
